import React, { useContext, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
import { FiAlertCircle } from 'react-icons/fi';
import { AuthContext } from '../../auth/AuthContext';
import { checkAccess } from '../../helpers/details';

const ModalDelPAgo = ({ show, onClose, info, callBk, method = 'DELETE', sat }) => {
    const { setResp } = useContextInfo();
    const { auth } = useContext(AuthContext);
    const { data, endpoint, head, body } = info;
    const [send, setSend] = useState(false);

    const permisos = checkAccess('Facturación', auth.accesos);
    const { fact_cancelar } = permisos.functions;
    const acepOk = async () => {
        if (send) return;
        setSend(true);
        const res = await fetchConToken(`${endpoint}`, { ...data }, method);
        setResp(res);
        callBk();
        setSend(false);
        onClose();
    };
    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header onHide={onClose} closeButton>
                <h4 className="modal-title">{head}</h4>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    <FiAlertCircle className="fs-1 inline-flex" />
                    <h3 className="mb-2 fs-4 font-normal ">{body}</h3>
                </div>
                <ul>
                    <li>La fecha de pago se cambiara a la anterior</li>
                    <li>Si el servicio estaba suspendido se suspendera</li>{' '}
                    <li>Si hay saldos no procesados estos seran eliminado</li> <li>si se creo factura se cancelara</li>{' '}
                    <li>si hay cargos procesados estos cambiaran a estado por cobrar</li>{' '}
                    <li>Si se relizo un cambio de plan al registrar el pago este volvera a su estado anterior</li>{' '}
                </ul>
                <div className="text-center">
                    {' '}
                    {sat && (
                        <div className="alert alert-warning" role="alert">
                            <b>El pago contiene una factura eléctronica, si elimina el pago la factura se cancelara</b>
                            <p>
                                Factura: Folio-{sat.folio} <br /> Razon: {sat.razon}
                            </p>
                        </div>
                    )}
                    {send ? (
                        <Button color="primary" disabled>
                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                            Procesando...
                        </Button>
                    ) : (
                        <>
                            {!sat ? (
                                <Button type="button" onClick={acepOk} variant="warning">
                                    Confirmar
                                </Button>
                            ) : (
                                <>
                                    {!fact_cancelar && (
                                        <div className="alert alert-info" role="alert">
                                            Consulte un administrador para eliminar el pago
                                        </div>
                                    )}
                                </>
                            )}
                            {fact_cancelar && sat && (
                                <Button type="button" onClick={acepOk} variant="warning">
                                    Confirmar
                                </Button>
                            )}
                        </>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModalDelPAgo;
